import {
    FlexiEditButton,
    PlatformPropertyCard,
    PlatformPropertyCardProperty
} from '@flexinet/ui-components';
import {useUserProfileAttributes} from '../hooks/useUserProfileAttributes';
import {
    Avatar,
    Card,
    Group,
    Text,
    ThemeIcon,
    Title
} from '@mantine/core';
import {AiOutlineSmile} from 'react-icons/ai';
import {useNavigate} from 'react-router-dom';
import {emptyState} from './emptyState';

export const AboutProfile = () => {

    const navigate = useNavigate();

    const {
        profile,
        nickname,
        birthDate,
        gender,
        picture,
    } = useUserProfileAttributes();

    const properties: PlatformPropertyCardProperty[] = [
        {
            label: 'Nickname',
            value: nickname || emptyState('Add a nickname'),
            span: 6,
        },
        {
            label: 'Gender',
            value: gender || emptyState('Not specified'),
            span: 6,
        },
        {
            label: 'Birth Date',
            value: birthDate || emptyState('Not specified'),
            span: 6,
        },
        {
            label: 'Profile URL',
            value: profile || emptyState('Add profile link'),
            span: 6,
        },
        {
            label: 'Photo',
            value: picture ? (
                <Group gap="sm" align="center">
                    <Avatar src={picture} size="md" radius="xl" alt="Profile photo"/>
                    <Text size="xs" c="dimmed" lineClamp={1} maw={200}>
                        {picture}
                    </Text>
                </Group>
            ) : emptyState('Add a photo URL'),
            span: 12,
        },
    ];

    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Group justify="space-between" mb="md">
                <Group gap="xs">
                    <ThemeIcon variant="outline" size="lg" color="blue">
                        <AiOutlineSmile size={20}/>
                    </ThemeIcon>
                    <Title order={5}>About</Title>
                </Group>
                <FlexiEditButton
                    onClick={() => navigate('/user-profile/update/#social')}
                    aria-label="Edit personal details and photo"
                />
            </Group>
            <PlatformPropertyCard properties={properties}/>
        </Card>
    );
};
